"use client";
import { useState, useEffect } from "react";

export type Device = "small-mobile" | "mobile" | "tablet" | "desktop";

function useDevice() {
    const [device, setDevice] = useState<Device>("desktop");

    useEffect(() => {
        // 디바이스 분류 함수
        const classifyDevice = (width: number): Device => {
            if (width < 768) {
                return "mobile";
            } else if (width >= 768 && width < 1024) {
                return "tablet";
            } else {
                return "desktop";
            }
        };

        // 초기 디바이스 감지
        const detectDevice = () => {
            if (typeof window !== "undefined") {
                setDevice(classifyDevice(window.innerWidth));
            }
        };

        // 리사이즈 핸들러
        const handleResize = () => {
            detectDevice();
        };

        // 초기 실행
        detectDevice();

        // 이벤트 리스너 등록
        window.addEventListener("resize", handleResize);

        // 클린업 함수
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    return device;
}

// width 400px 미만을 감지하는 훅
function useSmallDevice() {
    const [isSmallDevice, setIsSmallDevice] = useState<boolean>(false);

    useEffect(() => {
        // Small 디바이스 감지 함수
        const detectSmallDevice = () => {
            if (typeof window !== "undefined") {
                setIsSmallDevice(window.innerWidth < 400);
            }
        };

        // 리사이즈 핸들러
        const handleResize = () => {
            detectSmallDevice();
        };

        // 초기 실행
        detectSmallDevice();

        // 이벤트 리스너 등록
        window.addEventListener("resize", handleResize);

        // 클린업 함수
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    return isSmallDevice;
}

export default useDevice;
export { useSmallDevice };
